export default "__VITE_ASSET__DRAxl0TZ__"